import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { BookingsSectionTitle } from "./styles";
import { Form } from "antd";
import { useState } from "react";

const AuditLogInformation = ({ formData }) => {
  const [isDisabled, setIsDisabled] = useState(true);
  return (
    <>
      <Form disabled={isDisabled} initialValues={formData}>
        <StyledGridRow gutter={16}>
          <StyledGridCol span={5}>
            <FormItem name="action" label="Action">
              <TextField />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol span={5}>
            <FormItem name="appContext" label="Module">
              <TextField />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol span={4}>
            <FormItem name="moduleID" label="Module ID">
              <TextField />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol span={5}>
            <FormItem name="rootAppContext" label="Root AppContext">
              <TextField />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol span={5}>
            <FormItem name="recordNumber" label="Record #">
              <TextField />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>

        <StyledGridRow gutter={16}>
          <StyledGridCol flex="auto">
            <FormItem name="fullFieldSource" label="Table Path">
              <TextField />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol>
            <FormItem name="appContextKeyFieldID" label="Table ID">
              <TextField />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>

        <StyledGridRow gutter={16}>
          <StyledGridCol span={24}>
            <FormItem name="extraText" label="Extra Text">
              <TextField
                rows="6"
                inputType="textarea"
                style={{
                  backgroundColor: isDisabled ? "#f5f5f5" : "",
                  color: isDisabled ? "#a0a0a0" : "",
                }}
              />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>

        <BookingsSectionTitle>
          <span>Audit Log Administrative Information</span>
        </BookingsSectionTitle>

        <StyledGridRow gutter={16}>
          <StyledGridCol span={4}>
            <FormItem name="systemAuditLogID" label="ID">
              <TextField />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol span={6}>
            <FormItem name="dateAdded" label="Date Entered">
              <TextField />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol span={4}>
            <FormItem name="timeAdded" label="Time Entered">
              <TextField />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol span={6}>
            <FormItem name="userName" label="User">
              <TextField />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
    </>
  );
};
export default AuditLogInformation;
